import { render, staticRenderFns } from "./BrandDirectory.vue?vue&type=template&id=06e6ad68&lang=pug"
import script from "./BrandDirectory.vue?vue&type=script&lang=js"
export * from "./BrandDirectory.vue?vue&type=script&lang=js"
import style0 from "./BrandDirectory.vue?vue&type=style&index=0&id=06e6ad68&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports